<template>
  <div class="content_box">
    <!-- <div style=" font-size: 16px;">银行卡绑定</div> -->
    <div style="display: flex;justify-content: center;">
      <div class="step_box clearfix">
        <div class="f_l" style="width:35%">
          <div class="step_item">
            <div class="f_l">
              <div class="step_round"><i class="el-icon-check"></i></div>
              <div class="step_title" style="color: rgba(0,0,0,0.65);">填写账户信息</div>
            </div>
            <div style="flex:1">
              <div class="step_line"></div>
            </div>
          </div>
        </div>
        <div class="f_l" style="width:35%">
          <div class="step_item">
            <div class="f_l">
              <div class="step_round"><i class="el-icon-check"></i></div>
              <div class="step_title" style="color: rgba(0,0,0,0.65);">激活账户</div>
            </div>
            <div style="flex:1">
              <div class="step_line"></div>
            </div>
          </div>
        </div>
        <div class="f_l" style="width:20%">
          <div class="step_item">
            <div class="f_l step_ing">
              <div class="step_round">3</div>
              <div class="step_title">完成</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex;justify-content: center;width:85%">
      <div class="note_box">
          <div style="text-align: center;margin-bottom:16px">
            <img src="@/assets/complete.png" alt="" width="71px" height="71px">
          </div>
          <div style="font-size: 24px;color: rgba(0,0,0,0.85);line-height: 32px;text-align: center;">绑卡成功</div>
      </div>
    </div>
    <div style="display: flex;justify-content: center;width:85%">
      <div class="from_box">
        <div style="margin-bottom:24px">
          <span style="color: rgba(0,0,0,0.85);">银行户名：</span>
          <span style="color: rgba(0,0,0,0.65);">{{bankAccount}}</span>
        </div>
        <div style="margin-bottom:24px">
          <span style="color: rgba(0,0,0,0.85);">银行卡号：</span>
          <span style="color: rgba(0,0,0,0.65);">{{bankCard}}&nbsp;&nbsp;{{bankName}}</span>
        </div>
        <div style="margin-bottom:24px">
          <span style="color: rgba(0,0,0,0.85);">手机号码：</span>
          <span style="color: rgba(0,0,0,0.65);">{{phone}}</span>
        </div>
      </div>
    </div>
    <!-- <div class="tips_box">
      <div style="margin-bottom:12px">说明</div>
      <div style="font-size: 14px;color: rgba(0,0,0,0.45)">完成银行卡绑定后才能进行业务操作</div>
    </div> -->
    
  </div>
</template>

<script>
import fetchPost from "@/api/http.js";
export default {
  data() {
    return {
       bankAccount:"",
       bankCard:"",
       bankName:"",
       phone:"" 
    };
  },
  mounted(){
    //this.getBankCardInfo()
  },
  methods:{
    getBankCardInfo(accountId){
    console.log(accountId)
        fetchPost("/saas/bankAccountBind/getBankCardInfo", {accountId:accountId}).then(res => {
              this.bankAccount = res.bankAccount;
              this.bankCard = res.bankCard;
              this.bankName = res.bankName;
              this.phone = res.phone;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.f_l {
  float: left;
}
.from_box{
  font-size: 14px;
  margin-bottom: 90px !important;
}
.from_box .el-button{
  background: #DC1E32;
  color: #fff;
}
.note_box{
  margin-top: 54px !important;
  margin-bottom: 40px !important;
}
.content_box {
  color: #000;
  padding: 24px 32px !important;
  font-family: PingFangSC-Medium;
  .step_box {
    width: 800px;
    margin-top: 30px !important;
    .step_item {
      width: 100%;
      display: flex;
      .step_round {
        float: left;
        width: 32px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-right: 8px !important;
        border-radius: 50%;
      }
      .step_title {
        float: left;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.45);
        line-height: 32px;
      }
      .step_line {
        margin: 0 8px !important;
        margin-top: 15px !important;
        height: 1px;
        background: rgba(0, 0, 0, 0.15);
      }
      .step_ing {
        .step_round {
          background: #f6c7cc;
          color: #dc1e32;
          border: none;
        }
        .step_title {
          color: #000;
        }
      }
    }
  }
}
.tips_box {
    padding-top: 24px !important;
    border-top: 1px solid #E9E9E9;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.45);
  }
</style>